import Vue from 'vue'
import Router from 'vue-router'


import Home from '@/components/views/home'

import Login from '@/components/views/login'
import RecuperarPass from '@/components/views/recuperar-pass'
import listView from '@/components/views/list-view'
import vistaEncuesta from '@/components/views/vista-encuesta'
import encuestas from '@/components/views/encuestas'
import ofertascf from '@/components/views/ofertas-cf'

import accesoSAML from '@/components/views/acceso-saml';


import miperfil from '@/components/views/mi-perfil';

import mantenimiento from '@/components/views/mantenimiento'
import godmode from '@/components/views/god-mode'


import Error404 from '@/components/views/error-404'

import politicaCookies from '@/components/views/politica-de-cookies'
import politicaPrivacidad from '@/components/views/politica-de-privacidad'

Vue.use(Router)


import { store } from '@/store/store.js';


import messages from '@/translations';

let ca = messages.ca.enlaces;
let es = messages.es.enlaces;

let titles = messages.es.encabezado;

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/login',
			name: 'login',
			component: Login,
			meta: {
				requiresAuth: false,
				title: titles.login
			}
		},
		{
			path: '/mantenimiento',
			name: 'mantenimiento',
			component: mantenimiento,
			meta: {
				requiresAuth: false,
				title: 'Mantenimiento'
			}
		},
		{
			path: '/gma2019',
			name: 'godmode',
			component: godmode,
			meta: {
				requiresAuth: false,
				title: 'Gestor modo Dios'
			}
		},
		{
			path: es.restablecer_login,
			alias: ca.restablecer_login,
			name: 'restablecer-login',
			component: RecuperarPass,
			meta: {
				requiresAuth: false,
				name: 'restablecer_login',
				title: titles.restablecer_login
			}
		},
		{
			path: es.acceso,
			alias: ca.acceso,
			name: 'acceso',
			component: accesoSAML,
			meta: {
				requiresAuth: false,
				name: 'acceso',
				title: titles.acceso
			}
		},
		{
			path: '/',
			name: 'home',
			component: Home,
			children: [
				{
					path: `${es.validaciones}/:status?/:id?/:section?`,
					alias: `${ca.validaciones}/:status?/:id?/:section?`,
					component: listView,
					name: 'validaciones',
					meta: {
						indexPath: {
							es: es.validaciones,
							ca: ca.validaciones,
						}
					}
				},
				{
					path: `${es.tutorados}/:status?/:id?/:section?`,
					alias: `${ca.tutorados}/:status?/:id?/:section?`,
					component: listView,
					name: 'tutorados',
					meta: {
						indexPath: {
							es: es.tutorados,
							ca: ca.tutorados,
						}
					}
				},
				{
					path: `${es.aprobacionesdirector}/:status?/:id?/:section?`,
					alias: `${ca.aprobacionesdirector}/:status?/:id?/:section?`,
					component: listView,
					name: 'aprobaciones',
					meta: {
						indexPath: {
							es: es.aprobacionesdirector,
							ca: ca.aprobacionesdirector,
						}
					}
				},
				{
					path: `${es.ficha}/:id?/:section?`,
					alias: `${ca.ficha}/:id?/:section?`,
					component: listView,
					name: 'ficha',
					meta: {
						indexPath: {
							es: es.ficha,
							ca: ca.ficha,
						}
					}
				},
				{
					path: `${es.fichaaprobacion}/:id?/:section?`,
					alias: `${ca.fichaaprobacion}/:id?/:section?`,
					component: listView,
					name: 'aprobaciones',
					meta: {
						indexPath: {
							es: es.fichaaprobacion,
							ca: ca.fichaaprobacion,
						}
					}
				},
				{
					path: `${es.encuesta}/:id?`,
					path: `${ca.encuesta}/:id?`,
					name: 'encuesta',
					component: vistaEncuesta,
					meta: {
						requiresAuth: true,
						title: titles.vistaEncuesta
					}
				},
				{
					path: `${es.ofertaspracticas}/:status?/:id?`,
					name: 'ofertas-practicas',
					component: ofertascf,
					meta: {
						requiresAuth: true,
						title: titles.ofertascf
					}
				},
				{
					path: es.miperfil,
					path: ca.miperfil,
					name: 'mi-perfil',
					component: miperfil,
					meta: {
						requiresAuth: true,
						title: titles.vistaEncuesta
					}
				},
				{
					path: es.encuestas,
					path: ca.encuestas,
					name: 'encuestas',
					component: encuestas,
					meta: {
						requiresAuth: true,
						title: titles.vistaEncuesta
					}
				},
			],
			meta: {
				requiresAuth: true,
				title: titles.home
			}
		},
		// { path: '*', redirect: '/404' },
		// { path: "/404", component: Error404 }
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	},
});

import VueAnalytics from 'vue-analytics';

if (!!store.getters.getAnalitycs) {

	Vue.use(VueAnalytics, {
		id: store.getters.getAnalitycs,
		router,
		debug: {
			sendHitTask: store.getters.getInProduction,
		},

	});

}

router.beforeEach((to, from, next) => {

	let allowedMantenimiento = ['/mantenimiento', '/gma2019'];

	if ((!allowedMantenimiento.some(e => e == to.path)) & store.getters.getInMantenimiento & !!!store.getters.getGodmodeStatus) {
		next({ name: 'mantenimiento' })
		return

	} else {


		//COMPRUEBO INICIO DE SESIÓN Y SI ESTÁ LOGADO
		if (to.matched.some(route => route.meta.requiresAuth != false) && !store.getters.getLogged) {
			next({ name: 'login' })
			return
		}

		//COMPRUEBO SI TIENE SESIÓN INICIADA Y LE LLEVO A LA HOME
		if (to.path === '/login' && store.getters.getLogged) {
			next({ name: 'home' })
			return
		}

	}


	// if(!!to.meta.title){	
	// 	document.title = to.meta.title
	// 	//document.head.querySelector("[name=description]").content = meta.description;
	// }

	next()
});

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js